import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, X } from 'lucide-react';
export function SolutionSection() {
  return <section className="py-24 px-4 bg-[#FDF8F3] overflow-hidden" data-id="element-140">
      <div className="max-w-6xl mx-auto" data-id="element-141">
        {/* Why old solutions fail */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24" data-id="element-142">
          <FadeIn data-id="element-143">
            <h2 className="text-4xl md:text-5xl text-[#2D2A26] mb-8" data-id="element-144">
              Por qué lo que probaste no te funcionó
            </h2>
            <div className="space-y-6" data-id="element-145">
              <div className="flex items-start" data-id="element-146">
                <div className="flex-shrink-0 mt-1" data-id="element-147">
                  <X className="w-6 h-6 text-[#C4785B]" data-id="element-148" />
                </div>
                <div className="ml-4" data-id="element-149">
                  <h3 className="text-xl font-bold text-[#2D2A26] font-serif" data-id="element-150">
                    Probaste tips sueltos
                  </h3>
                  <p className="text-[#6B6560] mt-1" data-id="element-151">
                    Pero vos no necesitás tips. Necesitás un sistema.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-152">
                <div className="flex-shrink-0 mt-1" data-id="element-153">
                  <X className="w-6 h-6 text-[#C4785B]" data-id="element-154" />
                </div>
                <div className="ml-4" data-id="element-155">
                  <h3 className="text-xl font-bold text-[#2D2A26] font-serif" data-id="element-156">
                    Respirar no alcanza
                  </h3>
                  <p className="text-[#6B6560] mt-1" data-id="element-157">
                    Ayuda... si tu cuerpo no está sostenido por café, mal sueño
                    y estrés crónico.
                  </p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-158">
                <div className="flex-shrink-0 mt-1" data-id="element-159">
                  <X className="w-6 h-6 text-[#C4785B]" data-id="element-160" />
                </div>
                <div className="ml-4" data-id="element-161">
                  <h3 className="text-xl font-bold text-[#2D2A26] font-serif" data-id="element-162">
                    "Pensar positivo" falla
                  </h3>
                  <p className="text-[#6B6560] mt-1" data-id="element-163">
                    No sirve cuando lo que está prendido fuego es tu sistema
                    nervioso autónomo.
                  </p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} className="relative" data-id="element-164">
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-xl border border-[#E8DED5]" data-id="element-165">
              <h3 className="text-2xl font-serif text-[#1A6B5A] mb-6" data-id="element-166">
                Lo que necesitás es un sistema que:
              </h3>
              <ul className="space-y-4" data-id="element-167">
                <li className="flex items-center text-lg text-[#2D2A26]" data-id="element-168">
                  <span className="w-8 h-8 rounded-full bg-[#1A6B5A]/10 text-[#1A6B5A] flex items-center justify-center mr-4 font-bold text-sm" data-id="element-169">
                    1
                  </span>
                  Baje tu activación (cuerpo)
                </li>
                <li className="flex items-center text-lg text-[#2D2A26]" data-id="element-170">
                  <span className="w-8 h-8 rounded-full bg-[#1A6B5A]/10 text-[#1A6B5A] flex items-center justify-center mr-4 font-bold text-sm" data-id="element-171">
                    2
                  </span>
                  Cierre loops mentales (mente)
                </li>
                <li className="flex items-center text-lg text-[#2D2A26]" data-id="element-172">
                  <span className="w-8 h-8 rounded-full bg-[#1A6B5A]/10 text-[#1A6B5A] flex items-center justify-center mr-4 font-bold text-sm" data-id="element-173">
                    3
                  </span>
                  Proteja tu sueño (base)
                </li>
              </ul>
            </div>
            {/* Decorative blob */}
            <div className="absolute -z-10 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[#D4A853]/10 rounded-full blur-3xl" data-id="element-174"></div>
          </FadeIn>
        </div>

        {/* The 3E Map Reveal */}
        <div className="bg-[#1A6B5A] rounded-3xl p-8 md:p-16 text-white text-center relative overflow-hidden" data-id="element-175">
          <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-176">
            <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-177">
              <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-178">
                <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1" data-id="element-179" />
              </pattern>
              <rect width="100%" height="100%" fill="url(#grid)" data-id="element-180" />
            </svg>
          </div>

          <FadeIn className="relative z-10" data-id="element-181">
            <h2 className="text-4xl md:text-5xl mb-6 font-serif" data-id="element-182">
              El Mapa 3E: la pieza que te faltaba
            </h2>
            <p className="text-xl text-white/90 max-w-2xl mx-auto mb-12 leading-relaxed" data-id="element-183">
              Cuando te sentís mal, tu mente quiere explicación. Pero lo que
              necesitás primero es dirección. El Mapa 3E te dice qué palanca
              mover hoy:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left" data-id="element-184">
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20" data-id="element-185">
                <h3 className="text-2xl font-serif text-[#D4A853] mb-2" data-id="element-186">
                  Energía
                </h3>
                <p className="text-white/80" data-id="element-187">
                  ¿Estoy con deuda de sueño? ¿Necesito descanso real o
                  movimiento?
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20" data-id="element-188">
                <h3 className="text-2xl font-serif text-[#D4A853] mb-2" data-id="element-189">
                  Estrés
                </h3>
                <p className="text-white/80" data-id="element-190">
                  ¿Cuántos loops tengo abiertos? ¿Qué urgencias son reales?
                </p>
              </div>
              <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20" data-id="element-191">
                <h3 className="text-2xl font-serif text-[#D4A853] mb-2" data-id="element-192">
                  Estrógeno
                </h3>
                <p className="text-white/80" data-id="element-193">
                  ¿Estoy más sensible por oleadas hormonales? ¿Es mi fase del
                  ciclo?
                </p>
              </div>
            </div>

            <p className="mt-10 text-lg text-white/90 italic" data-id="element-194">
              En vez de hacer "todo", elegís una palanca. Eso baja el caos. Eso
              baja la culpa.
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}